// extracted by mini-css-extract-plugin
export default {"loader-aligment":"styles_loader-aligment__xJ3eG","custom-layout":"styles_custom-layout__fRcVS"};